import { render } from "./DeleteProductsModal.vue?vue&type=template&id=f8a0548c"
import script from "./DeleteProductsModal.vue?vue&type=script&lang=js"
export * from "./DeleteProductsModal.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/4schemplus/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__